import { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import NavTabs from '../../../NavTabs';

// Country counterpart to companyDetail/CompanyDetailMobileTabs: same sticky
// sentinel + horizontally scrollable pill row. Country has more tabs than
// Company can ever have, so unlike the company version this also asks
// NavTabs to auto-reveal the active tab (autoRevealActive) when the route
// changes, keeping deep sections like "Financials & Banks" scrolled into view.
const CountryDetailMobileTabs = ({ items, mapPage = false, className = '' }) => {
    const sentinelRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        if (mapPage) return undefined;

        const sentinel = sentinelRef.current;
        if (!sentinel) return undefined;

        const observer = new IntersectionObserver(
            ([entry]) => setIsSticky(!entry.isIntersecting),
            { rootMargin: '-112px 0px 0px 0px', threshold: 0 }
        );

        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [mapPage]);

    if (mapPage) {
        return (
            <Row className="mb-4 discovery-tabs-row">
                <Col>
                    <NavTabs
                        items={items}
                        className="discovery-route-tabs"
                        autoRevealActive
                        trackOverflow
                    />
                </Col>
            </Row>
        );
    }

    return (
        <>
            <span ref={sentinelRef} className="country-detail-mobile-tabs-sentinel" aria-hidden="true" />
            <Row className={`mb-4 mt-3 country-detail-mobile-tabs-row${isSticky ? ' is-sticky' : ''}${className ? ` ${className}` : ''}`}>
                <Col>
                    <NavTabs items={items} autoRevealActive trackOverflow />
                </Col>
            </Row>
        </>
    );
};

export default CountryDetailMobileTabs;
